<template>
    <div class="dashboard">
        <sp-360-panel :title='this.titulo' :tooltipOptions="topTooltipOptions" :footerText="ref">
          <div id="flex-box">
            <sp-map v-on:regiaoClicada="filtrarPorRegiao($event)" ref="mapa" id="mapaSP" ></sp-map>
            <div id="graficosDemograficos">
                <div id="ContainerMunicipal">
                  <span class="tituloGrafico">{{this.tituloMunicipal}}</span>
                  <grafico-piramide :cores='cores' :dados='dados' ref="graficoMunicipal"></grafico-piramide>
                </div>
                <div id="ContainerSubregional">
                  <span class="tituloGrafico">{{this.titulo + ' - ' + this.munAtual}}</span>
                  <grafico-piramide :cores='cores' :dados='dados' ref="graficoRegional"></grafico-piramide>
                </div>
            </div>
          </div>
        </sp-360-panel>
    </div>
</template>

<script>
import SpMap from '@/components/maps/360-maps/SPMap.vue'
import _ from 'lodash'
import MetodosGlobais from '@/utils/MetodosGlobais'
import CorUtil from '@/utils/CorUtils'
import GraficoPiramide from '@/components/statistics/charts/GraficoPiramide'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'
import * as d3 from 'd3'

export default {
  name: 'demografia-populacional',
  components: {
    SpMap,
    GraficoPiramide,
    Sp360Panel,

  },
  data () {
    return {
      titulo: this.$t('graficoDemografiaPopulacional.titulo'),
      tituloMunicipal: this.$t('graficoDemografiaPopulacional.tituloMunicipal'),
      ultimoClick: null,
      munAtual: this.$t('graficoDemografiaPopulacional.geral'),
      newData: {},
      chart1: {},
      chart2: {},
      listaDemografia: null,
      cores: [],
      coresMapa: {
        claro: '#f1f1fa',
        medio: '#9c9cd4',
        escuro: '#3b3b72',
      },
      dados: [],
      topTooltipOptions: {},
    }
  },
  created () {
    this.$store.dispatch('populacao/buscarPopulacaoPorIdadeSexo').then(
      retorno => {
        this.topTooltipOptions = { content: this.$t('graficoDemografiaPopulacional.tooltipDemografiaPopulacional'), placement: 'bottom' }
        this.listaDemografia = _.sortBy(retorno.data.data, ['id'], ['desc'])
        this.dados = _.cloneDeep(this.listaDemografia[0].dados)
        this.updateInicial()
        this.pintarTodasRegioes()

        // {fonte: fonte, data: dataRef}
        this.fonte = retorno.data.sigla_orgao
        this.dataRef = new Date(retorno.data.data_referencia_dado).toLocaleDateString('pt-BR')
        this.ref = this.$t('rodape.fonteData', { fonte: this.fonte, data: this.dataRef })
        this.sigla = retorno.sigla_orgao
      }
    )
  },
  methods: {
    criarLegenda () {
      this.$refs.mapa.definirLegenda([this.coresMapa.claro, this.coresMapa.medio, this.coresMapa.escuro],
        [this.$t('mainDashboard.legendaTitulo'), this.$t('mainDashboard.legendaBaixa'), this.$t('mainDashboard.legendaMedia'), this.$t('mainDashboard.legendaAlta')])
    },
    pintar (id) {
      this.$refs.mapa.pintarRegiao(id, CorUtil.getCorPorNomeSp360(CorUtil.VERDE_MEDIO))
    },
    pintarTodasRegioes () {
      let data = []
      for (let index = 1; index < this.listaDemografia.length; index++) {
        const regiao = this.listaDemografia[index]
        let populacaoRegional = 0
        regiao.dados.forEach(e => {
          populacaoRegional += e.feminino + e.masculino
        })
        data.push({ id: regiao.id, populacaoRegional: populacaoRegional })
      }

      data = _.sortBy(data, ['populacaoRegional'], ['asc'])

      let colorScale = d3.scaleLinear()
        .domain([_.first(data).populacaoRegional, _.last(data).populacaoRegional])
        .range([this.coresMapa.claro, this.coresMapa.escuro])
      data.forEach(o => {
        let id = 'sub' + o.id
        this.$refs.mapa.pintarRegiao(id, colorScale(o.populacaoRegional))
      })

      data = _.orderBy(data, ['populacaoRegional'])

      this.$refs.mapa.setLegenda(_.first(data).populacaoRegional, _.last(data).populacaoRegional, this.$t('graficoDemografiaPopulacional.textoEixoLegenda.piramideDemografica'), 5)
      this.criarLegenda()
    },
    filtrarPorRegiao (id) {
      let idNum = MetodosGlobais.idSvgToNumeric(id)
      let dados = this.listaDemografia[idNum].dados

      if (this.ultimoClick != id) {
        this.$refs.mapa.limparClick(this.ultimoClick)
        this.$refs.mapa.diminuirOpacidadeTodas()
        this.$refs.mapa.aumentarOpacidade(id)
        // this.pintar(id)
        this.$refs.graficoRegional.refreshDados(dados)
        this.ultimoClick = id
        this.munAtual = this.listaDemografia[idNum].nome
      } else {
        this.$refs.mapa.limparClick(id)
        this.$refs.mapa.aumentarOpacidadeTodas()
        this.$refs.graficoRegional.refreshDados(this.listaDemografia[0].dados)
        this.ultimoClick = null
        this.munAtual = 'Municípo'
      }
    },
    updateInicial () {
      this.$refs.graficoMunicipal.carregamentoInicial(_.cloneDeep(this.listaDemografia[0].dados))
      this.$refs.graficoRegional.carregamentoInicial(_.cloneDeep(this.listaDemografia[0].dados))
    },
  },
}

</script>

<style lang="scss" scoped>
  @media (min-width: 1000px) {
      #mapaSP{
          width: 35%;
      }

      #graficosDemograficos{
          width: 65%;
      }

      #ContainerSubregional{
          height: 50%;
      }

      #ContainerMunicipal{
          height: 50%;
      }

      #graficoMunicipal {
        height: 90%;
      }

      #graficoSubregional {
        height: 90%;
      }

      #flex-box{
        display: flex;
      }
  }

  @media (min-width: 561px) and (max-width: 999px) {
    #graficosDemograficos{
        width: 100%;
    }

    #ContainerSubregional{
        height: 100%;
    }

    #ContainerMunicipal{
        height: 100%;
    }

    #graficoMunicipal {
        min-height: 90%;
    }

    #graficoSubregional {
      height: 90%;
    }
  }

  @media (max-width: 560px) {
    #graficosDemograficos{
        width: 100%;
    }

    #ContainerSubregional{
        height: 100%;
    }

    #ContainerMunicipal{
        height: 100%;
    }

    #graficoMunicipal {
      height: 90%;
    }

    #graficoSubregional {
      height: 90%;
    }
  }

  .tituloGrafico {
  font-size: 24px;
  }

</style>
